import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'shc-no-record',
  templateUrl: './no-record.component.html',
  styleUrls: ['./no-record.component.scss'],
})
export class NoRecordComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
